import React, { useState } from 'react';
import API from '../../api';
import { useNavigate } from 'react-router-dom';

export default function CreateCustomer() {
  const [form, setForm] = useState({
    customer_name: '',
    contact_number: '',
    business_name: '',
    address: '',
    work_details: '',
    remark: '',
    lead_parsent: '',
    price: '',
    future_call_date: '',
    source: '',
  });

  const navigate = useNavigate();
  const [errors, setErrors] = useState([]);
  const [existingCustomer, setExistingCustomer] = useState(null);
  const [success, setSuccess] = useState('');
  const [skipValidation, setSkipValidation] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess('');
    try {
      const res = await API.post('/customers', {
        ...form,
        skipValidation,
      });

      setSuccess('Customer created successfully.');
      setForm({});
      navigate('/dashboard/followup-list');
    } catch (err) {
      if (err.response?.status === 409 && err.response.data.customer) {
        setExistingCustomer(err.response.data.customer);
        setErrors(['Contact number already exists.']);
      } else if (err.response?.data?.errors) {
        setErrors(Object.values(err.response.data.errors).flat());
      } else {
        setErrors(['Something went wrong.']);
      }
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="bg-white shadow-md rounded-xl">
        <div className="bg-blue-600 text-white text-lg font-semibold px-6 py-3 rounded-t-xl">
          Create New Customer
        </div>
        <div className="p-6 space-y-4">

          {/* Errors */}
          {errors.length > 0 && (
            <div className="bg-red-100 text-red-700 p-4 rounded-lg">
              <p className="font-bold mb-2">Whoops! Please fix the following errors:</p>
              <ul className="list-disc pl-5 space-y-1">
                {errors.map((e, i) => <li key={i}>{e}</li>)}
              </ul>
            </div>
          )}

          {/* Success */}
          {success && (
            <div className="bg-green-100 text-green-700 p-4 rounded-lg">
              {success}
            </div>
          )}

          {/* Existing Customer */}
          {existingCustomer && (
            <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg space-y-2">
              <p className="font-semibold">Contact Number Already Exists!</p>
              <p><b>Customer Name:</b> {existingCustomer.customer_name}</p>
              <p><b>Business Name:</b> {existingCustomer.business_name}</p>
              <p><b>Address:</b> {existingCustomer.address}</p>
              <p><b>Work Details:</b> {existingCustomer.work_details}</p>
              <p><b>Price:</b> {existingCustomer.price}</p>
              <p><b>Future Call Date:</b> {existingCustomer.future_call_date}</p>
              <p><b>Remark:</b> {
                Array.isArray(existingCustomer.remark)
                  ? <ul className="list-disc pl-5">{existingCustomer.remark.map((r, i) => <li key={i}>{r}</li>)}</ul>
                  : existingCustomer.remark
              }</p>
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="bg-yellow-600 text-white px-4 py-2 rounded hover:bg-yellow-700"
                  onClick={() => {
                    setSkipValidation(true);
                    setExistingCustomer(null);
                    setTimeout(() => {
                      document.getElementById('createCustomerForm').requestSubmit();
                    }, 0);
                  }}
                >
                  Create Existing Customer Anyway
                </button>
              </div>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} id="createCustomerForm" className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block mb-1 font-medium">Customer Name</label>
                <input type="text" name="customer_name" value={form.customer_name || ''} onChange={handleChange} required
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-1 font-medium">Contact Number</label>
                <input  type="number" name="contact_number" value={form.contact_number || ''} onChange={handleChange} required
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-1 font-medium">Source</label>
                <input type="text" name="source" value={form.source || ''} onChange={handleChange}
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-1 font-medium">Business Name</label>
                <input type="text" name="business_name" value={form.business_name || ''} onChange={handleChange}
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
            </div>

            <div>
              <label className="block mb-1 font-medium">Address</label>
              <textarea name="address" value={form.address || ''} onChange={handleChange}
                className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" rows="2" />
            </div>

            <div>
              <label className="block mb-1 font-medium">Work Details</label>
              <textarea name="work_details" value={form.work_details || ''} onChange={handleChange}
                className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" rows="2" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <label className="block mb-1 font-medium">Price</label>
                <input type="number" name="price" value={form.price || ''} onChange={handleChange}
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-1 font-medium">Future Call Date</label>
                <input type="date" name="future_call_date" value={form.future_call_date || ''} onChange={handleChange}
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-1 font-medium">Laed Percentage</label>
                <input type="text" name="lead_parsent" value={form.lead_parsent || ''} onChange={handleChange}
                  className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" />
              </div>
            </div>

            <div>
              <label className="block mb-1 font-medium">Remark</label>
              <textarea name="remark" value={form.remark || ''} onChange={handleChange}
                className="w-full border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500" rows="2" />
            </div>

            <div className="text-right">
              <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded">
                Create Customer
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
}
